var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"add-button button",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v("Add item")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }